import { Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import {
  PlanRemarksTable,
  PlanRequirementsTable,
} from '@components/Order/Numbers/Tables';
import { Page500 } from '@containers/ErrorPages';
import { planDetailsApi } from '@reducers/plan';
import { skipToken } from '@reduxjs/toolkit/query';

export const RequirementsTab = () => {
  const { showState } = useSelector((state) => state.plan.planInfo);
  const queryArg =
    showState.currentPlan.id && showState.currentPlan.type
      ? { ...showState.currentPlan }
      : skipToken;
  const { data, isLoading, isFetching, isError } =
    planDetailsApi.useGetRequirementsQuery(queryArg);
  if (isLoading || isFetching) {
    return <DefaultSpinnerCenter />;
  }
  if (isError) {
    return <Page500 />;
  }
  const { results, remarks } = data;
  return (
    <Row>
      <PlanRequirementsTable data={results} />
      <PlanRemarksTable data={[{ remarks }]} />
    </Row>
  );
};
